import { Button } from '@plato/ui/primitives/button';
import type { SerializedEditorState } from 'lexical';
import { SparklesIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { useAppConfig } from '../../acl/acl-provider.tsx';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import { ImproveTextDialog } from './improve-text-dialog.tsx';

type Props = {
    text: SerializedEditorState | undefined;
    onConfirmation: (text: SerializedEditorState, sessionId: string) => void;
    entityId?: string;
};

export function ImproveTextButton({ text, onConfirmation, entityId }: Props): ReactNode {
    const { t } = useLocale();
    const { enableAIWriting } = useAppConfig();

    if (!enableAIWriting) {
        return null;
    }

    return (
        <Button
            disabled={!text}
            intent="ai"
            variant="secondary"
            onClick={() => {
                if (!text) {
                    return;
                }

                void DialogStateManager.show(ImproveTextDialog, {
                    text,
                    onConfirmation,
                    entityId,
                });
            }}
            aria-label={t('rich_text_editor__improve_writing')}
        >
            <SparklesIcon />
            {t('rich_text_editor__improve_writing')}
        </Button>
    );
}
